export enum ProductTab {
  PRODUCTS = 'products',
  ADD_ONS = 'add-ons',
  ATTACHMENTS = 'attachments'
}
